export const isServerRender = () => typeof window === "undefined";
